import {
  Box,
  Button,
  LinearProgress,
  Stack,
  Text,
} from '@ltvco/refresh-lib/theme';
import { DateUtil } from '@ltvco/refresh-lib/utils';
import { useNavigate } from 'react-router-dom';

import { getPlanTitleAndDescription } from 'routes/Upgrade/plans';
import { useLimitedPlanInfo } from 'utils/useLimitedPlanInfo';

import { StyledAccountPageContainer, StyledDarkenedStack } from '../components';

import { StyledPlanUsageContent } from './components';

const dateUtil = new DateUtil();

export const PlanUsage = () => {
  const {
    isLimitedUser,
    isStaff,
    nextRenewalDate,
    reportLimit,
    reportsRun,
    reportsRunPercentage,
  } = useLimitedPlanInfo();

  const navigate = useNavigate();

  const planTitle = isStaff
    ? 'Staff'
    : getPlanTitleAndDescription(reportLimit).title;

  const parsedNextRenewalDate =
    dateUtil.parseDateFromString(nextRenewalDate, 'M/d/yyyy') || '';
  const shortRenewalDate =
    dateUtil.parseDateFromString(nextRenewalDate, 'MMM. d') || '';
  const daysRemaining = dateUtil.getDaysDiffFromNow(nextRenewalDate) || 0;

  const upgradeButton = (sx: object) => (
    <Button
      variant="contained"
      onClick={() => navigate('/chatbv/upgrade/plan')}
      sx={sx}
    >
      Upgrade Plan
    </Button>
  );

  return (
    <StyledAccountPageContainer>
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Text variant="h3">Plan Usage</Text>
        {upgradeButton({ display: { xs: 'none', sm: 'flex' } })}
      </Box>

      <StyledPlanUsageContent>
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'space-between',
            width: { xs: '100%', sm: 'auto' },
          }}
        >
          <Stack spacing={0.5}>
            <Text variant="caption" color="text.secondary">
              Current Plan:
            </Text>
            <Text fontWeight="bold">{planTitle}</Text>
            <Text variant="caption">Renews: {parsedNextRenewalDate}</Text>
          </Stack>

          {upgradeButton({ display: { xs: 'flex', sm: 'none' } })}
        </Box>

        {isLimitedUser && (
          <StyledDarkenedStack flex={1} sx={{ padding: 2 }}>
            <Stack spacing={1}>
              <Text>
                You've used <b>{reportsRun}</b> of <b>{reportLimit}</b> reports
                this cycle
              </Text>
              <LinearProgress
                value={reportsRunPercentage}
                variant="determinate"
                sx={{ borderRadius: '4px', height: '8px' }}
              />
              {!isStaff && (
                <Text variant="caption">
                  {daysRemaining > 0
                    ? `${daysRemaining} days remaining in your current cycle | New cycle starts ${shortRenewalDate}`
                    : daysRemaining === 0
                    ? `Your new cycle starts today (${shortRenewalDate})`
                    : `Your cycle expired ${Math.abs(
                        daysRemaining
                      )} days ago | New cycle started ${shortRenewalDate}`}
                </Text>
              )}
            </Stack>
          </StyledDarkenedStack>
        )}
      </StyledPlanUsageContent>
    </StyledAccountPageContainer>
  );
};
